/**
 * Created by zzy on 2019/8/6.
 */
// 引入 ECharts 主模块
let echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar')
// 引入提示框
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legendScroll')
export default {
  name: 'Bar',
  data () {
    return {
      echarts: echarts,
      barChart: null
    }
  },
  props: {
    id: {
      type: String,
      default: 'bar'
    },
    source: {
      type: Array,
      default: []
    },
    color: {
      type: Array,
      default: []
    }
  },
  mounted () {
    // this.draw()
  },
  methods: {
    draw () {
      let barElement = document.getElementById(this.id)
      if (!barElement) {
        return
      }

      if (!this.barChart) {
        this.barChart = this.echarts.init(barElement)
      } else {
        this.barChart.clear()
      }

      let series = []
      if (this.source[0] && this.source[0].length) {
        for (let i = 0; i < this.source[0].length - 1; i++) {
          // barMinHeight: 1 表示数值为零时也显示
          // barMaxWidth: 0 表示最大宽度为30像素
          let obj = {type: 'bar', color: this.color[i], barMinHeight: 1, barMaxWidth: 30}
          series.push(obj)
        }
      }

      // 绘制图表
      this.barChart.setOption({
        legend: {
          bottom: 10
        },
        tooltip: {},
        dataset: {
          source: this.source
        },
        grid: {
          top: 40,
          bottom: 60,
          right: 20,
          left: 50
        },
        xAxis: {type: 'category'},
        yAxis: {
          axisLine: {
            show: false
          }
        },
        series: series,
        animation: true,
        animationDuration: 2000,
        animationEasing: 'bounceOut'
      })
      // window.addEventListener('resize', () => {
      //   barChart.resize()
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/echarts/bar/Bar.js